export const DUPES_RESULT_PAGE_MATCH_LIMIT = 32
